module.exports = __webpack_public_path__ + "media/door.15def922.mp4";